module.exports = __webpack_public_path__ + "static/media/bio-2@2x.78dfb4cd.jpg";